<template>
  <svg
    width="19.08"
    height="<26.04"
    viewBox="0 0 91 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="color"
      d="M0 27.7591C0 12.4282 12.4282 8.61994e-06 27.7591 1.92532e-05L44 3.05176e-05H72L75 8L72 16H29.3001C22.4379 16 16.875 21.5629 16.875 28.4251V102.456C16.875 107.185 20.7085 111.019 25.4375 111.019C30.1664 111.019 34 107.185 34 102.456V101C34 93.8203 39.8203 88 47 88H50.2883V106.212C50.2883 120.454 38.7425 132 24.5 132C10.969 132 0 121.031 0 107.5V27.7591Z"
      fill="white"
    />
    <path
      d="M34 101C29.0294 101 25 96.9706 25 92L25 84.0684C25 77.396 30.396 71.9801 37.0683 71.9555L70.9977 71.9953C73.2073 71.9979 75 70.2073 75 67.9977C75 65.7898 73.2102 64 71.0023 64H41C32.1634 64 25 56.8366 25 48V44V40C24.8907 31.2501 31.9436 24.0931 40.6941 24.0742L71 24.0087C73.2105 24.0039 75 22.2105 75 20C75 17.7909 73.2091 16 71 16H70C75.4317 12.0497 75.4317 3.95035 70 0H70.3776C81.767 0 91 9.23297 91 20.6224C91 31.3244 82.3244 40 71.6224 40L45 40C42.7909 40 41 41.7909 41 44C41 46.2091 42.7909 48 45 48L70.8914 48C81.9971 48 91 57.0029 91 68.1086C91 79.0943 82.0943 88 71.1086 88H47C39.8203 88 34 93.8203 34 101Z"
      fill="#FFC56E"
    />
  </svg>
</template>
<script>
export default {
  props: {},
};
</script>

<style>
.color {
  /*target the image with css*/
  fill: var(--text-primary-color);
}
</style>
